import DatepickerCustom from './DatepickerCustom';

export default class FieldDate {

	constructor() {
		if ( ! this.setVars() ) return;

		this.setLocales();
		this.loadWidgets();
	}

	setVars() {
		this.inputs = document.querySelectorAll( '.load-datepicker input' );
		if ( ! this.inputs.length ) return;

		this.atts = {
			date_format: 'data-date-format',
			date_min: 'data-date-min',
			date_max: 'data-date-max',
			dates_disabled: 'data-dates-disabled',
			days_disabled: 'data-days-disabled',
			max_dates: 'data-max-dates',
			week_start: 'data-week-start',
		};
		this.config = {
			locales: window.fpf_pro_datepicker_locales || null,
		};

		return true;
	}

	setLocales() {
		const { locales } = this.config;
		if ( locales !== null ) {
			Object.assign( DatepickerCustom.locales, { en: locales } );
		}
	}

	loadWidgets() {
		const { length } = this.inputs;
		for ( let i = 0; i < length; i++ ) {
			new DatepickerCustom(
				this.inputs[ i ],
				this.getArgsForWidget( this.inputs[ i ] )
			);
			this.inputs[ i ].addEventListener( 'changeDate', this.sendEventChange.bind( this, this.inputs[ i ] ) );
		}
	}

	sendEventChange( input ) {
		const event = document.createEvent( 'Event' );
		event.initEvent( 'change', true, true );
		input.dispatchEvent( event );
	}

	getArgsForWidget( input ) {
		const dates_disabled = input.getAttribute( this.atts.dates_disabled ) || '';
		const days_disabled  = input.getAttribute( this.atts.days_disabled ) || '';
		const max_dates      = input.getAttribute( this.atts.max_dates ) || 1;
		return {
			format: input.getAttribute( this.atts.date_format ) || null,
			minDate: input.getAttribute( this.atts.date_min ) || null,
			maxDate: input.getAttribute( this.atts.date_max ) || null,
			datesDisabled: ( dates_disabled !== '' ) ? dates_disabled.split( ',' ) : [],
			daysOfWeekDisabled: ( days_disabled !== '' ) ? days_disabled.split( ',' ).map( Number ) : [],
			maxNumberOfDates: input.getAttribute( this.atts.max_dates ) || null,
			weekStart: input.getAttribute( this.atts.week_start ) || null,
			maxView: 2,
			todayHighlight: true,
			clear: false,
			autohide: ( parseInt( max_dates ) === 1 ),
			language: 'en',
		};
	}
}
